export default __webpack_public_path__ + "assets/study-info.png";